const state = {
    removeItem: undefined
}

const mutations = {
    SET_DATA: (state, data) => {
        state.removeItem = data
    }
}

const actions = {

}

const getters = {
    remove_item: (state, getters) => {
        return state.removeItem
    }
}
export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/listview.js